module.exports = __webpack_public_path__ + "static/media/notification.7073e4f7.svg";